var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAioaIconType4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 132,
    height: 132,
    viewBox: "0 0 132 132",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_21777",
    "data-name": "Group 21777",
    transform: "translate(-935 -316)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_6923",
    "data-name": "Ellipse 6923",
    transform: "translate(935 316)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 10
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 66,
    cy: 66,
    r: 66,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 66,
    cy: 66,
    r: 61,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "text-formatting",
    transform: "translate(960 348.996)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Page-1_23_",
    transform: "translate(0 0.001)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_x30_24---Text-Magnification"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape_37_",
    d: "M.091,122.508,22.869,63.59a2.825,2.825,0,0,1,2.65-1.823h8.8a2.849,2.849,0,0,1,2.65,1.823l22.764,58.918a1.425,1.425,0,0,1-1.325,1.937H49.423a1.441,1.441,0,0,1-1.339-.912L43.34,111.112a1.424,1.424,0,0,0-1.325-.912H17.826a1.441,1.441,0,0,0-1.339.912l-4.744,12.422a1.424,1.424,0,0,1-1.325.912H1.43a1.434,1.434,0,0,1-1.339-1.937Zm22.265-22.279H37.485a1.493,1.493,0,0,0,1.4-2.037L31.317,78.405a1.489,1.489,0,0,0-2.792,0L20.946,98.192a1.507,1.507,0,0,0,1.41,2.037Z",
    transform: "translate(22.783 -61.767)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_36_",
    d: "M349.112,270.569l11.553-30.413a2.849,2.849,0,0,1,2.664-1.838h4.131a2.849,2.849,0,0,1,2.664,1.838l5.185,13.647-3.447,8.946a1.327,1.327,0,0,0-.741-.214H359.667a1.425,1.425,0,0,0-1.325.9l-3.276,8.177a1.425,1.425,0,0,1-1.325.9h-3.3a1.424,1.424,0,0,1-1.325-1.937Zm12.864-13.732H368.8a.719.719,0,0,0,.67-1l-3.4-8.519a.712.712,0,0,0-1.339,0l-3.419,8.519a.725.725,0,0,0,.67,1Z",
    transform: "translate(-349.016 -209.828)",
    fill: "#fff"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAioaIconType4);
export default __webpack_public_path__ + "static/media/aioa-icon-type-4.bd88bad4f810da39119656b4f47be1c0.svg";
export { ForwardRef as ReactComponent };